export const ROOT_ROUTE = '/'

export const ASSISTANTS_ROUTE = '/assistants'
export const ASSISTANT_ADMINISTRATION_ROUTE = '/assistants-administration'
export const ASSISTANTS_SEARCH_ROUTE = '/assistants-search'
export const STORAGE_ROUTE = '/storage'
export const TEAM_ROUTE = '/team'
export const NOTIFICATIONS_ROUTE = '/notifications'
export const PROFILE_ROUTE = '/profile'
export const DIALOGS_ROUTE = '/dialogs'
export const FINANCES_ROUTE = '/finances'
export const ASSISTANT_SHOP_ROUTE = '/assistant-shop'
export const REFERRAL_PROGRAM_ROUTE = '/referral-program'
export const MEETS_ROUTE = '/meets'
export const CALENDAR_ROUTE = '/calendar'
export const DISK_ROUTE = '/disk'
export const RECORDS_ROUTE = '/records'
export const RECORD_ROUTE = '/record'
export const PROJECT_ROUTE = '/project'
export const SETTING_ROUTE = '/setting'
export const REQUESTS_ROUTE = '/requests'
export const REQUEST_ROUTE = '/request'
export const SHARE_ROUTE = '/share'
export const LOGIN_ROUTE = '/login'
export const SIGN_UP_ROUTE = '/sign-up'
export const FORGOT_PASSWORD_ROUTE = '/forgot-password'
export const WEB_VIEW_ROUTE = '/web-view'
export const TERMS_OF_USE_ROUTE = '/terms-of-use'
export const USER_AGREEMENT_ROUTE = `${TERMS_OF_USE_ROUTE}/user-agreement`
export const ASSISTANT_USAGE_AGREEMENT_ROUTE = `${TERMS_OF_USE_ROUTE}/ai-assistants`
export const PERSONAL_DATA_AGREEMENT_ROUTE = `${TERMS_OF_USE_ROUTE}/personal-data`
